<template>
    <div class="productAddWrap11_editProduct">
        <div class="formBox">
          <el-row :gutter="10">
            <el-col :span='8'>
              <p class="label">商品名称</p>
              <p class="text">{{ruleForm.name}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">所属公司</p>
              <p class="text">{{ruleForm.companyName}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">所属品牌</p>
              <p class="text">{{ruleForm.brand}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">商品ID</p>
              <p class="text">{{ruleForm.itemUniqueNumber}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">款号</p>
              <p class="text">{{ruleForm.kuanhao}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">颜色</p>
              <p class="text">{{ruleForm.color}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">尺码</p>
              <p class="text">{{ruleForm.size}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">类目</p>
              <p class="text">{{ruleForm.type}}</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">吊牌价</p>
              <p class="text">{{ruleForm.dpprice}}元</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">订货价</p>
              <p class="text">{{ruleForm.dhprice}}元</p>
            </el-col>
            <el-col :span='8'>
              <p class="label">是否为主推款</p>
              <p class="text">{{ruleForm.isMain}}</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <p class="label">商品图片</p>
              <div class="text top">
                <div class="imgBox" v-for="(list,index) in fileLists" :key="index">
                    <img :src="IMG_PREV+list" alt="" >
                </div>
              </div>
              
            </el-col>
          </el-row>
        </div>
    </div>
</template>

<script>
    import {json,wordData,utils} from '@/common/common.js'
    import {api,ajaxPost} from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                companyLists:[],
                brandLists:[],
                itemUniqueNumber:'',
                conferenceId:'',
                dialogImageUrl: '',
                dialogVisible: false,
                fileLists:[],
                ruleForm: {
                    company:'',
                    brand:'',
                    name:'',
                    kuanhao:'',
                    color:'',
                    size:'',
                    type:'',
                    isMain:'',
                    dpprice:'',
                    dhprice:'',
                    itemUniqueNumber:'',
                },
            }
        },
        computed: {
            IMG_PREV() {
                return api.imgPrev
            },
            
        },
        methods: {
            getDetail(){
                let _this=this
                let arg={
                  conferenceId:this.conferenceId ,
                  itemUniqueNumber:this.itemUniqueNumber
                }
                ajaxPost('/admin/showMallItem', arg).then(function(res) {
                    _this.ruleForm={
                        companyName:res.data.companyName,
                        brand:res.data.brandName,
                        name:res.data.itemName,
                        kuanhao:res.data.styleNumber,
                        color:res.data.colorName,
                        size:res.data.sizeNames?res.data.sizeNames.split(",").join(" "):'',
                        type:res.data.categoryName,
                        isMain:res.data.itemIsRecommend,
                        dpprice:res.data.itemOriginalPrice,
                        dhprice:res.data.itemOrderPrice,
                        itemUniqueNumber:_this.itemUniqueNumber,
                    }
                    _this.fileLists=res.data.images?res.data.images.split(","):[]
                   
                }, function(res) {
                
                })
            },
            getCompanyLists(){
                let _this=this
                let arg={
                    conferenceId:this.conferenceId
                }
                ajaxPost('/admin/addmallitemcompanyList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.companyLists=res.data
                    }
                     
                }, function(res) {
                
                })
            },
            getBrandLists(){
                let _this=this
                this.ruleForm.brand=''
                let arg={
                    userId:_this.ruleForm.company
                }
                ajaxPost('/admin/addmallitembrandList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.brandLists=res.data
                    }
                     
                }, function(res) {
                
                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                this.itemUniqueNumber = this.$route.params.itemUniqueNumber
            },
        },
        mounted(){
            this.getParams()
            this.getCompanyLists()
            this.getDetail()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .productAddWrap11_editProduct {
      background: #fff;
      padding:20px; border:1px solid #eee;
      .el-col{margin-bottom: 10px;}
      .label{display: inline-block;background: #eee;width: 100px;padding:10px;}
      .text{display: inline-block;}
      .top{vertical-align: top;}
      .imgBox{display: inline-block;  width: 140px; height: 140px;border:1px solid #eee; padding:5px; vertical-align: top;margin-right:10px; margin-bottom:10px;
          img{max-width: 100%;max-height: 100%;}
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/productDetail.vue